import { Extension as n } from "@tiptap/core";
const s = n.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["paragraph", "heading"],
      defaultHeight: "normal"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: this.options.defaultHeight,
            parseHTML: (e) => e.style.lineHeight,
            renderHTML: (e) => e.lineHeight ? {
              style: `line-height: ${e.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ commands: t }) => this.options.types.every(
        (i) => t.updateAttributes(i, { lineHeight: e })
      ),
      unsetLineHeight: () => ({ commands: e }) => this.options.types.every(
        (t) => e.resetAttributes(t, "lineHeight")
      )
    };
  }
});
export {
  s as LineHeight
};
